export const TIME_FRAME_WHOLE_PERIOD = 'whole-period';
export const TIME_FRAME_SINGLE_WEEK = 'single-week';

export const isWeekInTimelineRange = (weekNumber, year, range) => {
    if (!range) return false;

    const week = Number(weekNumber);
    const startWeek = Number(range.startWeek);
    const endWeek = Number(range.endWeek);
    if (!Number.isFinite(week) || !Number.isFinite(startWeek) || !Number.isFinite(endWeek)) {
        return false;
    }

    const startYear = Number(range.startWeekYear) || null;
    const endYear = Number(range.endWeekYear) || startYear;
    const y = Number(year) || null;

    if (startYear && endYear && y && (y === startYear || y === endYear || (y > startYear && y < endYear))) {
        if (startYear !== endYear) {
            if (y === startYear) return week >= startWeek;
            if (y === endYear) return week <= endWeek;
            return true;
        }
        return week >= startWeek && week <= endWeek;
    }

    if (startWeek <= endWeek) {
        return week >= startWeek && week <= endWeek;
    }

    return week >= startWeek || week <= endWeek;
};

export const createTimelineViewRange = ({ startWeek, startWeekYear, endWeek, endWeekYear }) => {
    const range = {
        startWeek,
        startWeekYear,
        endWeek,
        endWeekYear
    };

    return {
        ...range,
        isWeekInRange: (weekNumber, year) => isWeekInTimelineRange(weekNumber, year, range)
    };
};

export const isSingleWeekTimelineRange = (range) => {
    if (!range || !Number.isFinite(Number(range.startWeek))) {
        return false;
    }

    const sameWeek = Number(range.startWeek) === Number(range.endWeek);
    const sameYear = range.startWeekYear == null
        || range.endWeekYear == null
        || Number(range.startWeekYear) === Number(range.endWeekYear);

    return sameWeek && sameYear;
};

export const getSingleWeekFromTimelineRange = (range) => {
    if (!isSingleWeekTimelineRange(range)) return null;

    return {
        week: Number(range.startWeek),
        year: Number(range.startWeekYear) || Number(range.endWeekYear) || null
    };
};
